$(document).ready(function () {
  // Check every 500ms until the widget and shadow DOM are available
  try {
    $("[href='#gift'").click(function () {
      $("form-embed")[0].shadowRoot.querySelector("button").click();
    });
    const checkInterval = setInterval(() => {
      const shadowHost = document.querySelector("#app-embed-container-161501");
      console.log(shadowHost);
      // Check if the element exists and has a shadowRoot
      if (shadowHost && shadowHost.shadowRoot) {
        const button = shadowHost.shadowRoot.querySelector(
          'button[data-testid="teaser-container"]'
        );

        // If the button exists, hide it
        if (button) {
          button.style.display = "none";
        }

        // Inject CSS to hide the button
        const style = document.createElement("style");
        style.textContent = `
            button[data-testid="teaser-container"] {
                display: none !important;
            }
        `;
        shadowHost.shadowRoot.appendChild(style);
        console.log("check btn");
        // Stop checking once the element is found and modified
        clearInterval(checkInterval);
      }
    }, 1000); // Check every 1 second

    // Stop checking after 10 seconds
    setTimeout(() => clearInterval(checkInterval), 10000);
  } catch (error) {}
  $("[href='#accessibility'").click(function () {
    $("access-widget-ui")[2].shadowRoot.querySelector("button").click();
  });

  let intervalId = setInterval(function () {
    let widget = document.querySelector("access-widget-ui");

    if (widget && widget.shadowRoot) {
      // Stop checking further once the widget and shadowRoot are found
      clearInterval(intervalId);

      // Select the button inside the shadow DOM
      let shadowRootButton = widget.shadowRoot.querySelector(
        'button[part="acsb-trigger"]'
      );

      if (shadowRootButton) {
        // Add the custom class
        $(shadowRootButton).addClass("mycustomclass");

        // Apply inline styles directly to the button
        $(shadowRootButton).css({
          right: "auto",
          left: "20px",
          position: "fixed", // Ensure the button stays in the viewport
        });

        // Add custom CSS to enforce !important styles
        $("<style>")
          .prop("type", "text/css")
          .html(
            ".mycustomclass { right: auto !important; left: 20px !important; position: fixed !important; }"
          )
          .appendTo("head");

        console.log("Button style applied successfully.");
      } else {
        console.log("Button not found within shadow root.");
      }
    } else {
      console.log("Waiting for shadow root to become available...");
    }
  }, 500); // Check every 500 milliseconds
});
document.addEventListener("DOMContentLoaded", function () {
  const cartSpace = document.getElementById("cartSpace");
  if (cartSpace) {
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer) {
      cartSpace.appendChild(cartDrawer);
      cartDrawer.classList.remove("drawer");
      cartDrawer.classList.remove("is-empty");
    } else {
      console.warn("The #CartDrawer element is missing.");
    }
  }
  const stickyFilters = document.querySelector(".sticky_filters ul");
  if (stickyFilters != null) {
    removeListeners("#cart-icon-bubble");

    // const closeCartBtn = document.querySelector(".drawer__close");
    // closeCartBtn.addEventListener("click", () => {
    //   console.log("hideCart")
    //   hideCart();
    // });
    stickyFilterSetup(stickyFilters);
  }
});

function removeListeners(cssSelector) {
  var old_element = document.querySelector(cssSelector);
  if (!old_element || !old_element.parentNode) return null;
  var new_element = old_element.cloneNode(true);
  old_element.parentNode.replaceChild(new_element, old_element);
  return new_element;
}
function fixListener(cssSelector) {
  const btn = removeListeners(cssSelector);
  if (!btn) return;
  btn.querySelector(".collapsible-trigger__icon").classList.toggle("open")
  btn.onclick = function () {
    console.log(this.querySelector(".collapsible-trigger__icon").classList.toggle("open"))
  };
}
function fixFilter() {
  const targetElement = document.querySelector(
    '[data-index="mobile-1"] .mobile-facets__footer'
  );
  const detailDrawer = document.querySelector('[data-index="mobile-1"]')
  if (!detailDrawer) return;
  detailDrawer.setAttribute('open', '');
  detailDrawer.classList.add('menu-opening');
  // remove listeners
  fixListener('[data-index="mobile-1"] button');
  fixListener('[data-index="mobile-2"] button');
  fixListener('[data-index="mobile-3"] button');
  // Select the elements to be moved
  const elementsToInsert = [
    document.querySelector('[data-index="mobile-2"] button'),
    document.querySelector('[data-index="mobile-2"] ul'),
    document.querySelector('[data-index="mobile-3"] button'),
    document.querySelector('[data-index="mobile-3"] ul'),
  ];
  
  // Check if the target element and the elements to insert are found
  if (targetElement && elementsToInsert.every((el) => el)) {
    // Insert each element before the target element
    elementsToInsert.forEach((element) => {
      targetElement.parentNode.insertBefore(element, targetElement);
    });
  } else {
    console.error("One or more elements could not be found.");
  }
}
function showCart() {
  document.querySelector("#cartSpace").classList.add("show");
}
function closefilter() {
const filterrDrawer = document.querySelector('.mobile-facets__disclosure')
  filterrDrawer.removeAttribute('open', '');
}
function hideCart() {
  const cartSpace = document.querySelector("#cartSpace");
  if (cartSpace != null) cartSpace.classList.remove("show");
}

function stickyFilterSetup(stickyFilters) {
  fixFilter();
  // Check if there's a saved scroll position in localStorage
  const savedScrollPosition = localStorage.getItem("scrollPosition");
  if (savedScrollPosition) {
    //stickyFilters.scrollLeft = savedScrollPosition; // Set scroll position to saved value
  }
  stickyFilters.style.opacity = 1;
  // Save the current scroll position to localStorage when the user scrolls
  stickyFilters.addEventListener("scroll", () => {
    const scrollPosition = stickyFilters.scrollLeft;
    localStorage.setItem("scrollPosition", scrollPosition); // Save the scroll position
  });

  // Drag functionality (same as before)
  let isMouseDown = false;
  let startX;
  let scrollLeft;

  stickyFilters.addEventListener("mousedown", (e) => {
    isMouseDown = true;
    startX = e.pageX - stickyFilters.offsetLeft;
    scrollLeft = stickyFilters.scrollLeft;
    stickyFilters.style.cursor = "grabbing";
  });

  stickyFilters.addEventListener("mouseleave", () => {
    isMouseDown = false;
    stickyFilters.style.cursor = "grab";
  });

  stickyFilters.addEventListener("mouseup", () => {
    isMouseDown = false;
    stickyFilters.style.cursor = "grab";
  });

  stickyFilters.addEventListener("mousemove", (e) => {
    if (!isMouseDown) return;
    e.preventDefault();
    const x = e.pageX - stickyFilters.offsetLeft;
    const walk = x - startX; // Scroll speed multiplier
    stickyFilters.scrollLeft = scrollLeft - walk;
  });
}
